import React, { createContext, useState } from "react";
import IndexServices from "../services/IndexServices";
import Cookies from "js-cookie";
import Loader from "../general_components/Loader";
import SuccessMessage from "../general_components/SuccessMessage";
import ErrorMessage from "../general_components/ErrorMessage";
import {convertFromRaw, EditorState} from "draft-js";

export const TeamContext = createContext();

export default function TeamContextProvider({ children }) {

  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openDel, setOpenDel] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [clickedTeamId, setClickedTeamId] = useState(null);
  const [load, setLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [name, setName] = useState("");
  const [teamProfileImage, setTeamProfileImage] = useState("");
  const [teamProfileRawImage, setTeamProfileRawImage] = useState("");
  const [designation, setDesignation] = useState("");
  const [description, setDescription] = useState(EditorState.createEmpty());
  const [allTeam, setAllTeam] = useState([]);
  const storedRole = Cookies.get("role");

  // fetch Teams
  const fetchTeams = async () => {
    try {
      const response = await IndexServices.getTeam();
      setAllTeam(response?.data?.data);
    } catch (error) {
       setError(true);
       setErrorMessage("Something Went Wrong");
    }
  };

  // add Team
  const handleAddTeam = async (newTeam) => {
    setOpen(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("name", newTeam.name);
    formData.append("designation", newTeam.designation);
    formData.append("description", newTeam.description);
    formData.append("image", newTeam.image);
    await IndexServices.addTeam(formData)
      .then((response) => {
        if (response.data.success) {
          setAllTeam(response?.data?.data);
          fetchTeams();
          setOpen(false);
          setConfirm(true);
          setTimeout(() => {
            setConfirm(false);
          }, 2000);
        } else {
           setError(true);
           setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage("Something Went Wrong");
      });
    handleEmpty();
  };

  // edit Team
  const handleEditTeam = async (updatedTeamData, Id, oldTeamData) => {
    setOpen(true)
    setLoading(true);
    const formData = new FormData();
    if (
      updatedTeamData.name !== oldTeamData.name ||
      updatedTeamData.name !== ""
    ) {
      formData.append("name", updatedTeamData.name);
    }
    if (
      updatedTeamData.designation !== oldTeamData.designation ||
      updatedTeamData.designation !== ""
    ) {
      formData.append("designation", updatedTeamData.designation);
    }
    if (
      updatedTeamData.description !== oldTeamData.description ||
      updatedTeamData.description !== ""
    ) {
      formData.append("description", updatedTeamData.description);
    }
    if (updatedTeamData.image) {
      formData.append("image", updatedTeamData.image);
    }
    await IndexServices.editTeam(Id, formData)
      .then((response) => {
        if (response.data.success) {
          setAllTeam(response?.data?.data);
          fetchTeams();
          setOpen(false);
          setConfirm(true);
          setTimeout(() => {
            setConfirm(false);
          }, 2000);
        } else {
           setError(true);
           setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage("Something Went Wrong");
      });
    handleEmpty()
  };

  //  delete team
  const handleDeleteTeam = async () => {
    setOpen(true);
    setLoading(true);
    await IndexServices.deleteTeam(clickedTeamId, storedRole)
      .then((response) => {
        if (response.data.success) {
          fetchTeams();
          setOpen(false);
          setConfirm(true);
          setTimeout(() => {
            setConfirm(false);
          }, 2000);
        } else {
           setError(true);
           setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage("Something Went Wrong");
      });
  };

  const handleEmpty = () => {
    setName("");
    setTeamProfileImage("");
    setDesignation("");
    setDescription(null);
  };

  const handleAddData = (data) => {
    setName(data.name);
    setTeamProfileImage(data.image);
    setDesignation(data.designation);
    setDescription(!data.description ?
        EditorState.createEmpty() :
        EditorState.createWithContent(convertFromRaw(JSON.parse(data.description))) )
  };

  return (
    <TeamContext.Provider
      value={{
        handleAddTeam,
        handleDeleteTeam,
        open,
        setOpen,
        confirm,
        setConfirm,
        handleEditTeam,
        name,
        setName,
        teamProfileImage,
        setTeamProfileImage,
        designation,
        setDesignation,
        description,
        setDescription,
        allTeam,
        setAllTeam,
        teamProfileRawImage,
        setTeamProfileRawImage,
        fetchTeams,
        handleEmpty,
        handleAddData,
        openDel,
        setOpenDel,
        clickedTeamId,
        setClickedTeamId,
        load,
        setLoad,
        editMode,
        setEditMode,
      }}
    >
      {children}
      <Loader open={open} close={setOpen} />
      <SuccessMessage open={confirm} close={setConfirm} />
      <ErrorMessage open={error} close={setError} message={errorMessage} />
    </TeamContext.Provider>
  );
}
